<style lang="scss">
@import "./sass/screenwork.scss";
</style>

<script>
export default {
  name: "Main"
}
</script>
